import shared from "emun.order/order.config.es6"; //get shared
export const IS_SHOWROOM =
  (ENV_TAGS || []).indexOf("Showroom") >= 0;
export const IS_CMS = (ENV_TAGS || []).indexOf("Cms") >= 0; //webpack.DefinePlugin

const orderConfig = Object.assign({}, shared, {
  useNewCatalog: true,
  allowOrderEdit: true,
  enableQuotes: false,
  hideInvoicesTab: true,
  hideDetailNavTabs: true,
  hideDetailTopNav: true,
  showBulkActions: true,
  allowBackorders: true,
  showOrderExportQuickReport: true,
  hideMultiAddConfigMessage: true,
  OrderExportQuickReportName: "ExportLinesByOrderNumber",
  OrdersExportQuickReportName: "ExportLinesByOrderNumbers",
  //defaultDetailRoute: "quick-order",
  defaultDetailRoute: IS_SHOWROOM
  ? "orders.detail.lines"
  : "catalog",
getFirstDetailRoute: ($cart, $state, base, $session) => {
  if (IS_SHOWROOM) return { name: orderConfig.defaultDetailRoute };

  const detailRoutes = $state.getNav(base + ".detail");
  // console.debug("getFirstDetailRoute", {
	// envTags: ENV_TAGS,
	// IS_SHOWROOM,
	// detailRoutes,
	// $cart,
	// $state,
	// base,
	// $session,
  // });
  if ($cart.items.length) {
	//console.debug("getFirstDetailRoute.lines", detailRoutes[0]);
	return detailRoutes[0]; // lines
  }
  if ($cart.sourceId == "Direct" && $session.isAgency()) {
    console.debug("getFirstDetailRoute.lines", detailRoutes[0]);
    return detailRoutes[0]; // lines
  }
  console.debug("getFirstDetailRoute.catalogs", detailRoutes[3]);
  return detailRoutes[3]; // catalogs
},
  orderDefaultDateRangeSearch: "Last365",
  orderExportTemplate: "SalesOrdersExport",
  orderExportOrigin: "A4",
  //routes: [
  //	{ name: "lines", title: "Line Items",nav: 20, icon: "shopping-cart" },
  //	{ name: "shop", title: "Shop", nav: 40, icon: "search" },
  //	{ name: "catalogs", title: "Catalogs", nav: 60, icon: "file" },
  //],
  queryOptions: ($ctrl) => ({
    url: `QueryOrdersJoin.json?Status${
      $ctrl.mode === "Quote" ? "StartsWith" : "NotEqualTo"
    }=Quote`, //?StatusNotEqualTo=Cart',
    orderBy: "-OrderedOn,-Id",
    disableQueryString: false,
    pageSize: 12,
    criteria: {
      retailerId: $ctrl.customer ? $ctrl.customer.id : undefined,
    },
    views: {
      list: "th-list",
      cards: "th",
    },
    filters: [
      { groupBy: "Status", hidden: $ctrl.mode === "Quote", collapsed: true },
      {
        groupBy: "ErpStatus",
        title: "ERP Status",
        collapsed: true
      },
      { groupBy: "OrderSourceLabel", title: "Source", collapsed: true },
      { groupBy: "VendorLabel", title: "Vendor", collapsed: true },
      {
        date: "OrderedOn",
        title: $ctrl.mode === "Quote" ? "Quote Date" : "Order Date",
        collapsed: true
      },
      {
        groupBy: "CurrentRepName",
        title: "Rep # of Record",
        //roles: ["Administrator", "Sales Manager", "Web Admin", "Corporate"],
        authorize: (s) => s.isManagerOrAbove() || s.showMode,
        collapsed: true
      },
      {
        groupBy: "WritingRepName",
        title: "Writing Rep",
        collapsed: true,
        //roles: ["Administrator", "Sales Manager", "Web Admin", "Corporate"],
        authorize: (s) => s.isManagerOrAbove() || s.showMode,
      },
      { date: "ShipOn", title: "Ship Date", collapsed: true },
      { number: "GrandTotal", title: "Amount", collapsed: true },
      { groupBy: "ShowCodeName", title: "Show Code", collapsed: true },
      { groupBy: "Type", collapsed: true },
      { groupBy: "GeneratedFrom", collapsed: true },
    ],
    hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
    autoLoad: true,
    sortOptions: {
      Id: "Order No.",
      "-Id": "Order No.",
      "Status,-Id": "Status",
      "-Status,-Id": "Status",
      "PurchaseOrder,-Id": "PO#",
      "-PurchaseOrder,-Id": "PO#",
      "VendorLabel,-Id": "Vendor",
      "-VendorLabel,-Id": "Vendor",
      "CompanyName,-Id": "Customer",
      "-CompanyName,-Id": "Customer",
      "OrderedOn,-Id": "Order Date",
      "-OrderedOn,-Id": "Order Date",
      "ShipOn,-Id": "Ship Date",
      "-ShipOn,-Id": "Ship Date",
      "GrandTotal,-Id": "Amount",
      "-GrandTotal,-Id": "Amount",
    },
  }),
  startOrderMinInfo: true,
  hideAllowBackOrders: false,
  virtualSources: [{ id: "1", label: "ROAD" }, { id: "VIRTUAL", label: "VIRTUAL" }],
  showSources: ["SHOW","2"],
	defaultShowCodeFilter: false
});

export default orderConfig;
